var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _mask, _g2, _path7, _path8, _path9, _mask2, _g3, _path10, _path11, _path12, _path13, _path14, _path15, _mask3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthStartedBkg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 588,
    height: 1024,
    viewBox: "0 0 588 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 588,
    height: 1024,
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.248744,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.5 792C243.573 792 302 733.573 302 661.5C302 589.427 243.573 531 171.5 531C99.4268 531 41 589.427 41 661.5C41 733.573 99.4268 792 171.5 792Z",
    fill: "#673692"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-34.8356 1160.76C-80.026 1151.15 -109.178 1106.49 -99.618 1061.52L-70.5531 924.776C-60.993 879.799 -16.1971 850.859 28.9933 860.465C74.1837 870.07 103.336 914.728 93.7757 959.705L64.7108 1096.44C55.1507 1141.42 10.3548 1170.36 -34.8356 1160.76Z",
    fill: "#4C3A97"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-34.8356 1160.76V1160.76C-80.026 1151.15 -109.178 1106.49 -99.618 1061.52L-70.5531 924.776C-60.993 879.799 -16.1971 850.859 28.9933 860.465C74.1837 870.07 103.336 914.728 93.7757 959.705L64.7108 1096.44C55.1507 1141.42 10.3548 1170.36 -34.8356 1160.76",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0154 860.257L29.9717 860.673L-33.8572 1160.96L-35.8135 1160.55L28.0154 860.257Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.497 1117.47C412.047 1130.36 384.019 1123.47 371.214 1102.16L332.282 1037.36C319.477 1016.05 326.551 988.07 348.001 975.181C369.452 962.292 397.479 969.184 410.285 990.496L449.216 1055.29C462.021 1076.6 454.948 1104.58 433.497 1117.47Z",
    fill: "#4C3A97"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M433.497 1117.47V1117.47C412.047 1130.36 384.019 1123.47 371.214 1102.16L332.282 1037.36C319.477 1016.05 326.551 988.07 348.001 975.181C369.452 962.292 397.479 969.184 410.285 990.496L449.216 1055.29C462.021 1076.6 454.948 1104.58 433.497 1117.47",
    stroke: "white",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.573 975.439L348.43 974.924L433.926 1117.21L433.069 1117.73L347.573 975.439Z",
    stroke: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 346,
    y: 974,
    width: 89,
    height: 145
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.573 975.439L348.43 974.924L433.926 1117.21L433.069 1117.73L347.573 975.439Z",
    fill: "white",
    stroke: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M428.871 1109.11C404.816 1102.21 390.741 1077.02 397.594 1053.12L418.429 980.454C425.283 956.554 450.571 942.644 474.627 949.541C498.683 956.439 512.757 981.637 505.904 1005.54L485.069 1078.2C478.216 1102.1 452.927 1116.01 428.871 1109.11Z",
    fill: "#4C3A97"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M428.871 1109.11V1109.11C404.816 1102.21 390.741 1077.02 397.594 1053.12L418.429 980.454C425.283 956.554 450.571 942.644 474.627 949.541C498.683 956.439 512.757 981.637 505.904 1005.54L485.069 1078.2C478.216 1102.1 452.927 1116.01 428.871 1109.11",
    stroke: "white",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.146 949.404L475.108 949.679L429.352 1109.25L428.391 1108.97L474.146 949.404Z",
    stroke: "white"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 427,
    y: 948,
    width: 49,
    height: 162
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M474.146 949.404L475.108 949.679L429.352 1109.25L428.391 1108.97L474.146 949.404Z",
    fill: "white",
    stroke: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.497 1167.35C143.164 1174.8 105.698 1149.5 98.2392 1111.13L75.5619 994.464C68.1029 956.091 93.363 918.598 131.696 911.147C170.028 903.696 207.494 928.996 214.953 967.369L237.63 1084.03C245.089 1122.41 219.829 1159.9 181.497 1167.35Z",
    fill: "#4C3A97"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M181.497 1167.35V1167.35C143.164 1174.8 105.698 1149.5 98.2392 1111.13L75.5619 994.464C68.1029 956.091 93.363 918.598 131.696 911.147C170.028 903.696 207.494 928.996 214.953 967.369L237.63 1084.03C245.089 1122.41 219.829 1159.9 181.497 1167.35",
    stroke: "white",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.509 1167.51C180.838 1167.46 181.168 1167.41 181.497 1167.35C181.825 1167.29 182.146 1167.2 182.473 1167.13L132.683 910.985C132.354 911.043 132.024 911.082 131.695 911.146C131.367 911.21 131.046 911.297 130.72 911.367L180.509 1167.51Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1254 1141.69C50.1347 1143 28.6231 1123.75 27.3219 1098.92L23.3659 1023.44C22.0646 998.61 41.4469 977.224 66.4376 975.915C91.4283 974.605 112.94 993.848 114.241 1018.68L118.197 1094.16C119.498 1118.99 100.116 1140.38 75.1254 1141.69Z",
    fill: "#4C3A97"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1254 1141.69V1141.69C50.1347 1143 28.6231 1123.75 27.3219 1098.92L23.3659 1023.44C22.0646 998.61 41.4469 977.224 66.4376 975.915C91.4283 974.605 112.94 993.848 114.241 1018.68L118.197 1094.16C119.498 1118.99 100.116 1140.38 75.1254 1141.69",
    stroke: "white",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9383 975.941L66.937 975.888L75.6247 1141.66L74.6261 1141.71L65.9383 975.941Z",
    stroke: "white"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 975,
    width: 12,
    height: 168
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9383 975.941L66.937 975.888L75.6247 1141.66L74.6261 1141.71L65.9383 975.941Z",
    fill: "white",
    stroke: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 5.66233,
    y: 495.662,
    width: 331.675,
    height: 331.675,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17.6688,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 294,
    y1: 0,
    x2: 294,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5244A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#483D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthStartedBkg);
export default __webpack_public_path__ + "static/media/auth-started-bkg.831ae1d85cddecc1eda503194d13bb40.svg";
export { ForwardRef as ReactComponent };